// extracted by mini-css-extract-plugin
export var cruiseTagsContainer = "CruiseEventTags-module--cruise-tags-container--933b0";
export var cruiseTagsRecapTitle = "CruiseEventTags-module--cruise-tags-recap-title--eef8c";
export var divider = "CruiseEventTags-module--divider--6f913";